const activeSlideBg = document.querySelector('.slider-background')
const container = document.querySelector('.home-slider-swiper-container')
const perViewDesktopAttr = container && container.dataset.perViewDesktop
const perViewDesktop = perViewDesktopAttr ? Number(perViewDesktopAttr) : 4 // дефолт 4
const slidesCount = container ? container.querySelectorAll('.swiper-wrapper > .swiper-slide').length : 0
const shouldLoop = slidesCount > perViewDesktop

const isMobile = () => {
    return window.matchMedia('(max-width: 768px)').matches
}

const swiper = new Swiper('.home-slider-swiper-container', {
    on: {
        init: (swiper) => {
            onSwiperInit(swiper)
        },
        slideChange: (swiper) => {
            const image = isMobile() ? swiper.slides[swiper.activeIndex].dataset.imageMobile : swiper.slides[swiper.activeIndex].dataset.image
            setActiveSlideBg(image)
        }
    },
    loop: shouldLoop,
    navigation: {
        nextEl: '.swiper-home-button-next',
        prevEl: '.swiper-home-button-prev',
    },
    breakpoints: {
        1: {
            slidesPerView: 1.2,
        },
        768: {
            slidesPerView: 2.2
        },
        1024: {
            slidesPerView: 4
        },
        1440: {
            slidesPerView: perViewDesktop

        }
    }
})

function onSwiperInit(swiper) {
    const currentActiveSlide = swiper.slides[swiper.activeIndex]
    const currentActiveSlideImage = isMobile() ? currentActiveSlide.dataset.imageMobile : currentActiveSlide.dataset.image

    setActiveSlideBg(currentActiveSlideImage)

    swiper.slides.forEach((slide, index, slides) => {
        slide.onmouseenter = (e) => {
            if (swiper.activeIndex === index) {
                return
            }

            const tempActiveSlide = e.target
            const image = isMobile() ? tempActiveSlide.dataset.imageMobile : tempActiveSlide.dataset.image

            slides[swiper.activeIndex].classList.remove('swiper-slide-active')
            tempActiveSlide.classList.add('swiper-slide-active')

            setActiveSlideBg(image)
        }

        slide.onmouseleave = (e) => {
            if (swiper.activeIndex === index) {
                return
            }

            const currentActiveSlide = slides[swiper.activeIndex]
            const currentActiveSlideImage = isMobile() ? currentActiveSlide.dataset.imageMobile : currentActiveSlide.dataset.image

            slides[swiper.activeIndex].classList.add('swiper-slide-active')
            e.target.classList.remove('swiper-slide-active')

            setActiveSlideBg(currentActiveSlideImage)
        }
    })

}

function setActiveSlideBg(imageUrl) {
    activeSlideBg.style.backgroundImage = `url(${imageUrl})`
}
